import { render } from "./FairSeeds.vue?vue&type=template&id=5be981c6&scoped=true"
import script from "./FairSeeds.vue?vue&type=script&lang=js"
export * from "./FairSeeds.vue?vue&type=script&lang=js"

import "./FairSeeds.vue?vue&type=style&index=0&id=5be981c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be981c6"]])

export default __exports__